import { render, staticRenderFns } from "./ItensEnvioChecklist.vue?vue&type=template&id=cc6f3c44&scoped=true"
import script from "./ItensEnvioChecklist.vue?vue&type=script&lang=js"
export * from "./ItensEnvioChecklist.vue?vue&type=script&lang=js"
import style0 from "./ItensEnvioChecklist.vue?vue&type=style&index=0&id=cc6f3c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6f3c44",
  null
  
)

export default component.exports